import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import hu from "./locales/hu";

const STORAGE_KEY = "AFFEKTRA_LANG";

const savedLang = localStorage.getItem(STORAGE_KEY) || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hu: { translation: hu },
  },
  lng: savedLang,
  fallbackLng: "en",
  returnNull: false,
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export const LANGUAGES = [
  { id: "en", label: "English", icon: "🇬🇧" },
  { id: "hu", label: "Magyar", icon: "🇭🇺" },
];

export const setLanguage = (lang: string) => {
  i18n.changeLanguage(lang);
  localStorage.setItem(STORAGE_KEY, lang);
};

export const getCurrentLanguage = () => i18n.language;

export default i18n;
